import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Spinner.module.scss'

interface ISpinnerProps {
  // The banner strip is shorter than a page of results.
  row?: boolean
}

// Chewy's loader: a brand-blue ring with a clear quarter, centred in the block it stands in for.
const Spinner = ({ row = false }: ISpinnerProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.box} ${row ? style.row : ''}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Spinner"
    >
      <span className={style.ring} />
    </div>
  )
}

export default Spinner
